import GuestIndexVue from "@/views/guest/GuestIndex.vue";

const guest = [
    {
        path: '/guest',
        name: 'guest',
        component: GuestIndexVue
    }
]

export default guest;